module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAgMAAAANjH3HAAAADFBMVEUAAADHx8fJycnKysqfrdWaAAAAA3RSTlMAQIDntwj7AAAAVElEQVRIx2P4/4EBO2I4wIAdMOOUYcAjM9CAGY/MgQGWGQ230XCjtYwIznDTwOnSgZBhxiNzgN4y/P9B4MNouJEuIzKaT0fLt9FwG2rhxv+fASsCAG3JSU1ZVIZ5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_image.png
// module id = 834
// module chunks = 0 1 2 3 4 5